import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/standard-button';
import { IconButton } from '@atlaskit/button/new';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import type { TriggerProps } from '@atlaskit/popup';

import { useChoreographerAssets } from '@confluence/choreographer-services';

import { i18n } from './messages';
import { InfoContainer, FeedbackContainer } from './SharedComponents';

type EndOfPageRecommendationInfoPopupProps = {
	toggleInfo: () => void;
	showFeedbackButton?: boolean;
	clickFeedback?: () => void;
	isInfoOpen: boolean;
	handleInfoButtonRef: (triggerProps: TriggerProps) => (node: HTMLButtonElement | null) => void;
};

export const EndOfPageRecommendationInfoPopup = ({
	toggleInfo,
	showFeedbackButton,
	clickFeedback,
	isInfoOpen,
	handleInfoButtonRef,
}: EndOfPageRecommendationInfoPopupProps) => {
	const { Popup } = useChoreographerAssets();

	return (
		<Popup
			shouldRenderToParent
			onClose={toggleInfo}
			content={() => (
				<InfoContainer>
					<FormattedMessage {...i18n.info} />
					{showFeedbackButton && (
						<FeedbackContainer>
							<Button onClick={clickFeedback}>
								<FormattedMessage {...i18n.feedback} />
							</Button>
						</FeedbackContainer>
					)}
				</InfoContainer>
			)}
			isOpen={isInfoOpen}
			placement="top"
			trigger={(triggerProps) => (
				<IconButton
					appearance="subtle"
					onClick={toggleInfo}
					isSelected={isInfoOpen}
					testId="eop-info-button"
					icon={StatusInformationIcon}
					label={<FormattedMessage {...i18n.infoButton} />}
					{...triggerProps}
					ref={handleInfoButtonRef(triggerProps)}
				/>
			)}
		/>
	);
};
